export const GeaoPaths = Object.freeze({
    // Create your profile flow
    CreateYourProfileChecklist: '/onboarding-overview',
    CreateYourProfile: '/pre-onboarding',
    CreateYourProfileKickout: '/onboarding-kickout',
    PreOnboardingNationalAccountPrefix: '/pre-onboarding-',

    // Principal flow
    PrincipalWelcomeChecklist: '/agency-overview',
    // PrincipalReviewProfileInformation: '/onboarding-review-profile-info',
    PrincipalPersonalInformation: '/onboarding-principal-personal-info',
    PrincipalBackgroundInformation: '/onboarding-background-information',
    PrincipalRequestAuthorizedRep: '/onboarding-request-delegate',
    PrincipalAgencyOfficeInformation: '/onboarding-agency-office-info',
    PrincipalAgencyEmployeeInformation: '/onboarding-employee-information',
    PrincipalAgencyFinancialInformation: '/onboarding-agency-financial-details',
    PrincipalAgencyAdditionalInformation: '/onboarding-agency-additional-info',
    PrincipalErrorsAndOmissions: '/onboarding-errors-and-omissions',
    PrincipalBankingInformation: '/onboarding-banking-details',
    PrincipalW9TaxForm: '/onboarding-w9-tax-form',
    PrincipalReviewAndSign: '/onboarding-agency-review-sign',
    PrincipalApplicationSubmitted: '/onboarding-principal-congrats',
    PrincipalKickout: '/onboarding-agency-kickout',

    // Producer flow
    ProducerWelcomeChecklist: '/agent-overview',
    //ProducerReviewProfileInformation: '/onboarding-agent-review-profile-info',
    ProducerPersonalInformation: '/onboarding-agent-personal-information',
    ProducerBackgroundInformation: '/onboarding-agent-background-information',
    ProducerSubmitApplication: '/onboarding-agent-submit-application',
    ProducerReviewAndSign: '/onboarding-agent-review-and-sign',
    ProducerApplicationSubmitted: '/onboarding-agent-congrats',
    ProducerKickout: '/onboarding-agent-kickout',

    // Recall flow
    ApplicationStatus: '/onboarding-recall-search',
    RecallVerification: '/onboarding-recall-verification',
    RecallSendCode: '/onboarding-recall-send-code',

    // Application Status
    PrincipalBackgroundCheckInProgress: '/onboarding-principal-background-overview',
    PrincipalApplicationInProgress: '/onboarding-principal-in-progress-overview',
    PrincipalApplicationComplete: '/onboarding-principal-complete-overview',

    ProducerApplicationInProgress: '/onboarding-agent-in-progress-overview',
    ProducerBackgroundCheckInProgress: '/onboarding-agent-background-overview',
    ProducerApplicationComplete: '/onboarding-agent-complete-overview',
    BackgroundCheckDenial: '/onboarding-background-check-denial',

    // Tech Diff page
    TechnicalDifficulties: '/onboarding-tech-diff',
    SessionExpired: '/session-expired',
    OnboardingPaused: '/onboarding-paused'
});